import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "./store";
// import VueMeta from "vue-meta"; //if needed - add "vue-meta": "^2.4.0" in package.json
import VueSimpleMarkdown from "vue-simple-markdown";
import "vue-simple-markdown/dist/vue-simple-markdown.css";

Vue.config.errorHandler = (err, vm, info) => {
	console.error(err)

	// File Name and Line Number
	const stack = err.stack || "";
	const match = stack.match(/at\s+.*\((.*):(\d+):(\d+)\)/);
	const fileName = match && match[1].match(/\.\/src\/.*?\.vue/) ? match[1].match(/\.\/src\/.*?\.vue/)[0] : "unknown file";
	const lineNumber = match ? match[2] : "unknown line";

	// Device
	const userAgent = navigator.userAgent;
	let device = 'unknown';

	if (/Macintosh|Windows|x11/i.test(userAgent)) {
		device = 'Desktop / Laptop';
	} else if (/tablet/i.test(userAgent)) {
		device = 'Tablet';
	} else if (/mobile/i.test(userAgent)) {
		device = 'Mobile';
	}

	// Browser
	let browser = 'unknown';

	if (/chrome/i.test(userAgent)) {
		browser = 'Google Chrome';
	} else if (/firefox/i.test(userAgent)) {
		browser = 'Mozilla Firefox';
	} else if (/safari/i.test(userAgent)) {
		browser = 'Apple Safari';
	} else if (/opera|opr/i.test(userAgent)) {
		browser = 'Opera';
	} else if (/edge/i.test(userAgent)) {
		browser = 'Microsoft Edge';
	} else if (/msie|trident/i.test(userAgent)) {
		browser = 'Internet Explorer';
	}

	// Operating System
	const operatingSystem = navigator.platform;

	const baseURL = process.env.VUE_APP_API_URL || 'https://1api.goleko.com/api'
	const data = {
		level: 'error',
		msg: JSON.stringify({
			err: err.toString() || err,
			info: info,
			baseURL: process.env.BASE_URL,
			location: window.location.href,
			device: device || 'unknown',
			browser: browser || 'unknown',
			filePath: fileName || 'unknown',
			lineNumber: lineNumber || 'unknown',
			operatingSystem: operatingSystem || 'unknown'
		}),
	};

	const token = localStorage.getItem('token');
	const headers = {};
	if (token) {
		headers.Authorization = `Bearer ${token}`;
	}

	axios.post(`${baseURL}/general/fe_error`, data, { headers })
	.then(res => {

	})
}

Vue.use(VueSimpleMarkdown);
// Vue.use(VueMeta);
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
